module.exports = __webpack_public_path__ + "media/images/cms/img_slide_10-cab3b8f04b4578fb9811aacf746a7bd4.jpg";